import { render, staticRenderFns } from "./MDeparts.vue?vue&type=template&id=8c962dc6&scoped=true"
import script from "./MDeparts.vue?vue&type=script&lang=js"
export * from "./MDeparts.vue?vue&type=script&lang=js"
import style0 from "./MDeparts.vue?vue&type=style&index=0&id=8c962dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c962dc6",
  null
  
)

export default component.exports